module.exports = __webpack_public_path__ + "static/img/project-hyperdrive.e14c822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-hyperdrive.png
// module id = LKvG
// module chunks = 0